import React from 'react'
import {Route, Switch, withRouter, Redirect} from 'react-router-dom'
import AccountOverview from '../Common/AccountOverview'

const PammRoutes = ({match: {path}}) => (
  <Switch>
    <Redirect from={`${path}/transactions`} to="/transactions/:accountId/history"/>
    <Route exact path={`${path}`} component={AccountOverview} />
  </Switch>
)

export default withRouter(PammRoutes)
